const GOOGLE_DOMAINS = [
    "com",
    "co.jp",
    "co.uk",
    "es",
    "ca",
    "de",
    "it",
    "fr",
    "com.au",
    "com.br",
    "com.gr",
    "co.in",
    "co.id",
    "com.mx",
    "dk",
    "com.ar",
    "ch",
    "cl",
    "at",
    "co.kr",
    "ie",
    "com.co",
    "pl",
    "pt",
    "com.pk",
].map((suffix) => `www.google.${ suffix }`);

const YAHOO_DOMAIN_PREFIXES = [
    "",
    "us",
    "ca",
    "uk",
    "in",
    "au",
    "nl",
    "nz",
    "sg",
    "de",
    "es",
    "ln",
    "fr",
];
const joinDomainTokens = (domainTokens) => domainTokens.filter((token) => token).join(".");

const YAHOO_SEARCH_DOMAINS = YAHOO_DOMAIN_PREFIXES
    .map((prefix) => joinDomainTokens([prefix, "search.yahoo.com"]));
const YAHOO_VIDEO_SEARCH_DOMAINS = YAHOO_DOMAIN_PREFIXES
    .map((prefix) => joinDomainTokens([prefix, "video.search.yahoo.com"]));

const DOMAIN_TO_GROUP_MAPPING = {
    "drudgereport.com": "DRUDGEREPORT",
    "www.drudgereport.com": "DRUDGEREPORT",
    "m.facebook.com": "FACEBOOK",
    "www.facebook.com": "FACEBOOK",
    "lm.facebook.com": "FACEBOOK",
    "l.facebook.com": "FACEBOOK",
    "t.co": "TWITTER",
    "www.twitter.com": "TWITTER",
    "www.linkedin.com": "LINKEDIN",
    "lnkd.in": "LINKEDIN",
    "touch.www.linkedin.com": "LINKEDIN",
    "plus.url.google.com": "GOOGLE_PLUS",
    "www.reddit.com": "REDDIT",
    "www.bing.com": "BING_SEARCH",
    "bing.com": "BING_SEARCH",
};

GOOGLE_DOMAINS
    .forEach((googleDomain) => DOMAIN_TO_GROUP_MAPPING[googleDomain] = "GOOGLE_SEARCH");
YAHOO_VIDEO_SEARCH_DOMAINS
    .forEach((yahooDomain) => DOMAIN_TO_GROUP_MAPPING[yahooDomain] = "YAHOO_SEARCH");
YAHOO_SEARCH_DOMAINS
    .forEach((yahooDomain) => DOMAIN_TO_GROUP_MAPPING[yahooDomain] = "YAHOO_SEARCH");

const DOMAIN_GROUP_TO_CATEGORY_MAPPING = {
    "INTERNAL_WEB": "INTERNAL",
    "INTERNAL_MOBILE": "INTERNAL",
    "FACEBOOK": "SOCIAL",
    "LINKEDIN": "SOCIAL",
    "TWITTER": "SOCIAL",
    "GOOGLE_PLUS": "SOCIAL",
    "REDDIT": "SOCIAL",
    "DRUDGEREPORT": "NEWS_PORTALS",
    "GOOGLE_SEARCH": "SEARCH",
    "BING_SEARCH": "SEARCH",
    "YAHOO_SEARCH": "SEARCH",
    "OTHERS": "OTHERS",
};

const DOMAIN_GROUP = {
    INTERNAL_WEB: "INTERNAL_WEB",
    INTERNAL_MOBILE: "INTERNAL_MOBILE",
    FACEBOOK: "FACEBOOK",
    LINKEDIN: "LINKEDIN",
    TWITTER: "TWITTER",
    GOOGLE_PLUS: "GOOGLE_PLUS",
    REDDIT: "REDDIT",
    DRUDGEREPORT: "DRUDGEREPORT",
    GOOGLE_SEARCH: "GOOGLE_SEARCH",
    BING_SEARCH: "BING_SEARCH",
    YAHOO_SEARCH: "YAHOO_SEARCH",
    OTHERS: "OTHERS",
};

const WEB_INTERNAL_DOMAIN = ".bloomberg.com";
const MOBILE_INTERNAL_PROTOCOL = "mobile://";

const getDomainCategory = (referrerUrl) => {
    const domainGroup = getDomainGroup(referrerUrl);
    let domainCategory = DOMAIN_GROUP_TO_CATEGORY_MAPPING[domainGroup];

    if (!domainCategory) {
        domainCategory = DOMAIN_GROUP_TO_CATEGORY_MAPPING.OTHERS;
    }

    return domainCategory;
};

const getDomainGroup = (referrerUrl) => {
    const internalDomain = checkAndGetInternalDomain(referrerUrl);

    if (internalDomain !== null) {
        return internalDomain;
    }

    const webreferrerUrl = getWebreferrerUrl(referrerUrl);

    if (webreferrerUrl === null) {
        return DOMAIN_GROUP.OTHERS;
    }

    if (isAndroidQuickSearchBox(webreferrerUrl) || isChromeSuggestions(webreferrerUrl)) {
        return DOMAIN_GROUP.GOOGLE_SEARCH;
    }

    const host = webreferrerUrl.host;
    let domainGroup = DOMAIN_TO_GROUP_MAPPING[host];

    if (!domainGroup) {
        domainGroup = DOMAIN_GROUP.OTHERS;
    }

    return domainGroup;
};
const isAndroidQuickSearchBox = ({ pathname, hostname }) =>
    pathname
    && pathname.indexOf("//com.google.android.googlequicksearchbox") === 0
    && hostname === "android-app";

const isChromeSuggestions = ({ pathname, hostname }) =>
    pathname
    && pathname.indexOf("/auth/chrome-content-suggestions") === 0
    && hostname === "googleapis.com";

const getWebreferrerUrl = (referrerUrl) => {
    let retVal = null;
    const referrerUrlRegex = RegExp("^(http|https)://.*$");

    if (referrerUrl && referrerUrl.length > 0) {
        let decodedreferrerUrl = decodeURI(referrerUrl);

        decodedreferrerUrl = getreferrerUrlWithoutQueryParams(decodedreferrerUrl);
        decodedreferrerUrl = referrerUrlRegex.test(decodedreferrerUrl) ? decodedreferrerUrl : `http://${ decodedreferrerUrl }`;
        retVal = new URL(decodedreferrerUrl);
    }

    return retVal;
};

const checkAndGetInternalDomain = (referrerUrl) => {
    let retVal = null;

    if (referrerUrl && referrerUrl.length > 0) {
        const referrerUrlWithoutQuery = getreferrerUrlWithoutQueryParams(referrerUrl);

        if (referrerUrlWithoutQuery.indexOf(WEB_INTERNAL_DOMAIN) !== -1) {
            retVal = DOMAIN_GROUP.INTERNAL_WEB;
        }

        if (referrerUrlWithoutQuery.indexOf(MOBILE_INTERNAL_PROTOCOL) !== -1) {
            retVal = DOMAIN_GROUP.INTERNAL_MOBILE;
        }
    }

    return retVal;
};

const getreferrerUrlWithoutQueryParams = (referrerUrl) => {
    return referrerUrl.split("\\?", 2)[0];
};

const getSourceInformation = (referrerUrl, urlParams) => {
    if (!urlParams) {
        return undefined; // Likely on mobile
    }

    let retVal = "Direct";
    const source = urlParams.get("utm_source") || referrerUrl;
    const medium = urlParams.get("utm_medium") || "";
    const SEARCH_ENGINES = ["google", "bing", "yahoo"];
    const EXTENDED_SEARCH_ENGINES = SEARCH_ENGINES.concat(["duckduckgo"]);
    const NEWSLETTER_SOURCES = ["offer", "nurture"];
    const NEWSLETTER_REGEX = /.*newsletter.*/;
    const SOCIAL_REGEX = [
        "fb",
        "t.co",
        ".*facebook.*",
        ".*twitter.*",
        ".*instagram.*",
        ".*likeshop.*",
        ".*reddit.*",
        ".*linkedin.*",
        ".*snapchat.*",
    ];

    try {
        if (medium === "display") {
            return "Display";
        }

        if (source === "webpush") {
            return "Web_Push";
        }

        if (EXTENDED_SEARCH_ENGINES.indexOf(source) !== -1) {
            if (medium === "cpc") {
                return "Paid_Search";
            }

            return "Organic_Search";
        }

        if (SEARCH_ENGINES.indexOf(source) === -1 && medium === "cpc") {
            return "Paid_Social";
        }

        const newsLetterSourceIndex = NEWSLETTER_SOURCES.indexOf(source);

        if ((newsLetterSourceIndex === -1 && medium === "email")
            || NEWSLETTER_REGEX.test(source)
            || NEWSLETTER_REGEX.test(medium)) {
            return "Newsletter";
        }

        if (newsLetterSourceIndex !== -1 && medium === "email") {
            const nls = NEWSLETTER_SOURCES[newsLetterSourceIndex];

            return `Email_${ nls.charAt(0).toUpperCase() }${ nls.slice(1) }`;
        }

        const socialRegex = new RegExp(SOCIAL_REGEX.join("|"), "i");

        if (socialRegex.test(source) && medium !== "cpc") {
            return "Organic_Social";
        }

        // Referral is traffic coming from another site that cannot be attributed to any of the above
        // We identify this traffic as traffic that has a non-null value for either the utm_source query parameter or the
        // referer HTTP header.
        if (source !== "") {
            return "Referral";
        }
    } catch (e) {
        retVal = "Direct";
    }

    return retVal;
};

export {
    getDomainCategory,
    getSourceInformation,
};
